export function documentIdsKey(ids: readonly number[]): string {
    return [...ids].sort((left, right) => left - right).join(",");
}
